import { useCallback } from "react";
import { useFlightSearch } from "./useFlightsSearch";
import {
  useFlightSelectionPayloadContext,
  type MappedFlightOffer,
} from "../../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "../useFlightSearchTokens";
import { useFlightFiltersContext } from "../../context/FlightFiltersContext";
import type { FlightSearchPagedResultData } from "./types";
import { getOfferByIdFromSearchResult } from "./utils";

export const useSelectedOffer = () => {
  const { selectedOfferIndex, selectedFlightSearchSource } =
    useFlightSelectionPayloadContext();
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { query: tokensQuery } = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const { filters } = useFlightFiltersContext();

  const select = useCallback(
    (response: FlightSearchPagedResultData) =>
      getOfferByIdFromSearchResult(response, selectedOfferIndex),
    [selectedOfferIndex],
  );

  return useFlightSearch<MappedFlightOffer | undefined>(
    selectedFlightSearchSource === "quick" ? quickTokensQuery : tokensQuery,
    filters,
    {
      select,
    },
  );
};
